import { Modal } from "flowbite-react";
import FormRemoveCollector from "../forms/FormRemoveCollector";

interface ModalRemoveCollectorProps {
    open: boolean;
    onClose: () => void;
    repossessionId: string;
    collectorId: string;
    onSuccess?: () => void; 
}

export default function ModalRemoveCollector({
    open,
    onClose,
    repossessionId,
    collectorId,
    onSuccess,
}: ModalRemoveCollectorProps) {
    return (
        <Modal show={open} size="md" onClose={onClose} popup>
            <Modal.Header />
            <Modal.Body>
                <FormRemoveCollector
                    repossessionId={repossessionId}
                    collectorId={collectorId}
                    onClose={onClose}
                    onSuccess={onSuccess}
                />
            </Modal.Body>
        </Modal>
    );
}
